import { render, staticRenderFns } from "./vinPlateRepeatReviewPage.vue?vue&type=template&id=8a7657f8&scoped=true"
import script from "./vinPlateRepeatReviewPage.vue?vue&type=script&lang=js"
export * from "./vinPlateRepeatReviewPage.vue?vue&type=script&lang=js"
import style0 from "./vinPlateRepeatReviewPage.vue?vue&type=style&index=0&id=8a7657f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7657f8",
  null
  
)

export default component.exports